import z from "zod";
export const strokeGripSchema = z.enum(["light", "normal", "tight"]);
export const strokeGrip = strokeGripSchema.options;
export const strokeStyleSchema = z.enum(["full", "head", "shaft"]);
export const strokeStyle = strokeStyleSchema.options;
export const strokeHandSchema = z.enum(["dominant", "non-dominant"]);
export const strokeHand = strokeHandSchema.options;
